import { useState, useEffect } from "react";
import { debounce } from "../../delays/debounce.js";
const useMatchMedia = (mediaString) => {
  const [match, setMatch] = useState();
  useEffect(() => {
    const media = window.matchMedia(mediaString);
    setMatch(media.matches);
    const resizeHandler = debounce((_) => {
      const media2 = window.matchMedia(mediaString);
      setMatch(media2.matches);
    }, 200);
    window.addEventListener("resize", resizeHandler);
    return () => window.removeEventListener("resize", resizeHandler);
  }, [mediaString]);
  return match;
};
export {
  useMatchMedia
};
